import { render, staticRenderFns } from "./Alias.vue?vue&type=template&id=040cd0f5&scoped=true&"
import script from "./Alias.vue?vue&type=script&lang=ts&"
export * from "./Alias.vue?vue&type=script&lang=ts&"
import style0 from "./Alias.vue?vue&type=style&index=0&id=040cd0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040cd0f5",
  null
  
)

export default component.exports